import { useEffect, useState } from 'react'

interface AiPopUpProps {
  delay?: number // ms
  message?: string
  className?: string
}

const DEFAULT_MESSAGE = 'Hello! I am AL\nYour AI assistant'

function AiPopUp({ delay = 1000, message = DEFAULT_MESSAGE, className = '' }: AiPopUpProps) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), delay)
    return () => clearTimeout(timer)
  }, [delay])

  if (!visible) return null

  return (
    <div className={`ai-popup ${className}`} data-testid='ai-popup'>
      <div className='ai-popup-bubble'>
        <button aria-label='Close' className='ai-popup-close-btn' onClick={() => setVisible(false)}>
          ×
        </button>
        <div className='ai-popup-message'>
          {message.split('\n').map((line, i) => (
            <span key={i}>
              {line}
              {i < message.split('\n').length - 1 && <br />}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}

export { AiPopUp }
